import Modal from '@hotmart/space-lib/dist/components/modal'
import ProgressBar from '@hotmart/space-lib/dist/components/progressBar'
import styled from 'styled-components'

export const CustomProgressBar = styled(ProgressBar)`
  height: 0.7rem;
`

CustomProgressBar.displayName = 'CustomProgressBar'

export const CustomModal = styled(Modal)`
  --modal-backdrop-pointer-events: none;
`

CustomModal.displayName = 'CustomModal'
